import { createStyles } from '@mui/styles';
import { APTheme } from '../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({

    resourcesItemContainer: {
        position: 'relative',
        '& h2': {
            fontSize: '26px',
            lineHeight: '34px',
            color: '#4a4a4a',
            textAlign: 'center',
            margin: '0 0 5rem 0',
            fontWeight: '600',
            letterSpacing: '-1px',
            '@media(max-width: 768px)': {
                margin: '0 0 3rem 0',
                fontSize: '22px',
            },
        },
    },
    resourcesItemContainerPDF: {
        '& h2': {
            margin: '0 0 4rem 0'
        }
    },
    resourcesItem: {
        position: 'relative',
        maxWidth: 635,
        background: 'white',
        padding: '32px',
        fontSize: 16,
        lineHeight: '18px',
        boxSizing: 'border-box',
        margin: '0 auto 1.875rem',
        boxShadow: '0 1px 4px 0 rgba(0,0,0,0.08)',
        backgroundColor: '#fff',
    },
    resourcesItemPDf: {
        maxWidth: '100%',
        padding: '30px 32px 30px 30px',
        [theme.breakpoints.down('lg')]: {
            padding: '10px',
        }
    },
    resourcesImg: {
        position: 'relative',
        width: '100%',
        verticalAlign: 'top',
        paddingBottom: 32,
        boxSizing: 'border-box',
        margin: 'auto',
        textAlign: 'center',
        '& img': {
            height: 'auto',
            maxWidth: 550,
            width: 'auto',
            maxHeight: 400,
            boxShadow: '0 0px 28px 0 rgba(0,0,0,0.10)',
        }
    },
    resourcesCopy: {
        letterSpacing: '-0.5px',
        paddingTop: 32,
        position: 'relative',
        borderTop: '1px solid #ececec'
    },

    resourcesPdf: {
        textAlign: 'center',
        width: '100%',
        '& > div': {
            width: '100%',
            height: 650
        }
    },
    resourcesBtn: {
        display: 'block',
        //width: '190px',
    },
    resourcesPdfBtn: {
        display: 'flex',
        marginLeft: 'auto'
    },
    resourcesSpinner: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        margin: 'auto',
    },
    resourcesCopyTitle: {
        fontSize: '19px',
        lineHeight: '24px',
        color: '#4a4a4a',
        margin: 0,
        fontWeight: 500
    },
    resourcesDownloadError: {
        fontSize: 16,
        lineHeight: '24px',
        color: '#f44336',
        margin: '15px 0 0 0',
        fontWeight: 400
    },
    resourcesCopySubTitle: {
        fontSize: '17px',
        lineHeight: '24px',
        color: '#a4a4a4',
        margin: '0 0 20px 0',
        fontWeight: 400,
    },
    resourcesCopyText: {
        fontSize: '14px',
        lineHeight: '18px',
        color: '#4a4a4a',
        margin: '0 0 15px 0',
    },
    resourcesCopyHtml: {
        backgroundColor: '#f7f7f7',
        whiteSpace: 'pre-wrap',
        fontSize: '85%',
        lineHeight: '1.5',
        padding: 15,
        borderRadius: 3,
    },
    resourcesActions: {
        marginTop: 16,
        padding: '10px 0 0 0',
        color: '#e8e8e8',
        '& button, & a': {
            display: 'inline-block',
            cursor: 'pointer',
            fontFamily: 'CircularStd',
            fontSize: '16px',
            fontWeight: 500,
            padding: 0,
            lineHeight: '1.13',
            color: '#2d91e9',
            border: 'none',
            textDecoration: 'none',
            marginRight: 10,
            background: 'transparent',
            '&:focus, &:active': {
                outline: 'none',
            },
            '&:disabled': {
                opacity: '0.5'
            },
            '& svg': {
                verticalAlign: 'bottom',
                fontSize: '120%',
                width: '1em',
                height: '1em'
            },
            '&.resourcesPdfBtn':{
                display: 'flex',
                marginLeft: 'auto'
            }
        },
        '& span': {
            display: 'inline-block',
            marginRight: 10,
        },
    },
    resourcesActionsPdf: {
        marginTop: 0,
        padding: 0,
    },
    loadingIcon: {
        display: 'inline-block',
        marginLeft: 15,
        verticalAlign: 'bottom'
    },
    pdfLoadingIcon: {
        display: 'inline-block',
        marginRight: 15,
        verticalAlign: 'bottom'
    },
    APSnackBar: {
        width: '100%',
        maxWidth: 600,
        margin: 'auto',
        position: 'absolute',
        top: 0,
        color: '#2D91E9',
        background: '#EAF3FF',
        boxSizing: 'border-box',
        padding: '20px',
        boxShadow: '0 5px 12px 0 rgba(0,0,0,0.08)',
        fontSize: 16,
        justifyContent: 'flex-start',
        '& div': {
            width: '100%',
            boxSizing: 'border-box',
            textAlign: 'left',
            display: 'flex',
            alignItems: 'center',
            letterSpacing: '-0.5px',
            '& svg': {
                width: '20px',
                height: '20px',
                verticalAlign: 'middle',
            }
        }
    },
    svgTick: {
        marginRight: 6,
    },
    svgIconClose: {
        cursor: 'pointer',
        pointerEvents: 'all',
        marginLeft: 'auto'
    },
    pdfHeader: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    }
});
